import 'arrive';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.arrive('.block-page-intro-animated', { existing: true }, function () {
    const section = this;
    const wrapper = section.querySelector('.block-page-intro-animated__wrapper');
    const content = section.querySelector('.block-page-intro-animated__content');
    const imageContainer = section.querySelector('.block-page-intro-animated__container-image');

    if (!wrapper || !content || !imageContainer) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Ferma i video decorativi se l'utente ha richiesto riduzione del movimento
    if (prefersReducedMotion) {
        section.querySelectorAll('video').forEach(video => {
            video.pause();
            video.removeAttribute('autoplay');
        });
        return;
    }

    // --- FUNZIONI DI CALCOLO DINAMICO ---
    
    const getInitialMetrics = () => {
        const isMobile = window.innerWidth < 1200;
        const margin = isMobile ? 60 : 100;
        const wHeight = wrapper.offsetHeight;
        const cHeight = content.offsetHeight;

        // Calcolo posizione bordo inferiore del testo centrato
        const contentBottom = (wHeight / 2) + (cHeight / 2);
        
        return {
            top: contentBottom + margin,
            width: isMobile ? wrapper.offsetWidth * 0.8 : 646,
            height: isMobile ? wHeight * 0.35 : 450
        };
    };

    // --- SETUP REATTIVO CON MATCHMEDIA ---

    let mm = gsap.matchMedia();

    mm.add("(min-width: 0px)", () => {
        gsap.set(imageContainer, {
            position: 'absolute',
            left: '50%',
            xPercent: -50,
            zIndex: 3,
            transformOrigin: 'top center',
            overflow: 'hidden',
            // Usiamo funzioni per rendere top, width e height reattivi al resize
            top: () => getInitialMetrics().top,
            width: () => getInitialMetrics().width,
            height: () => getInitialMetrics().height
        });

        // Timeline dell'animazione
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: wrapper,
                start: 'top top+=16',
                end: '+=100%',
                scrub: 1,
                pin: true,
                invalidateOnRefresh: true, // Fondamentale: ricalcola tutto se ridimensioni
            }
        });

        tl.to(imageContainer, {
            width: '100%',
            height: '100%',
            top: 0,
            ease: 'none'
        }, 0);

        tl.to(content, {
            y: -100,
            opacity: 0,
            ease: 'power1.out'
        }, 0);

        return () => {
            // Cleanup opzionale
        };
    });

    // --- GESTIONE EVENTI ESTERNI ---

    // Forza ScrollTrigger a ricalcolare se il media carica dopo il DOM
    const img = imageContainer.querySelector('img');
    if (img && !img.complete) {
        img.addEventListener('load', () => ScrollTrigger.refresh());
    }

    const videos = imageContainer.querySelectorAll('video');
    videos.forEach(video => {
        if (video.readyState < 2) { // HAVE_CURRENT_DATA non ancora raggiunto
            video.addEventListener('loadeddata', () => ScrollTrigger.refresh(), { once: true });
        }
    });

    // Invece di setupPosition() manuale, ScrollTrigger.refresh()
    // scatenerà le funzioni top: () => ... definite sopra
    window.addEventListener('resize', () => {
        ScrollTrigger.refresh();
    });
});